import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { EnvironmentCustomerType } from '@mwe/environment';

@Component({
  selector: 'mwe-header-logo-image',
  templateUrl: './header-logo-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderLogoImageComponent {
  readonly customerType = input<EnvironmentCustomerType>();

  readonly altText = computed<string>(() => {
    if (this.customerType() === EnvironmentCustomerType.COMMUNITY) return 'Wien Energie Zukunftswerkstatt Home';

    return 'Wien Energie Stencil';
  });
}
